export default __webpack_public_path__ + "static/media/willem-olding.a6215f94.png";